// Standalone axios calls for refresh/logout (no app `client()` interceptors) so Authorization
// is taken only from the explicit Bearer passed here — avoids races with redux clearing auth
// before axios@0.21 request interceptors run on a shared instance.
import Axios from 'axios';
import { apiBaseUrl } from '../config';

const jsonHeaders = (authorization) => ({
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'x-source-type': 'admin',
  ...(authorization ? { Authorization: authorization } : {}),
});

export const refreshTokenApi = (refreshToken) =>
  Axios.post(
    `${apiBaseUrl}/restaurants/refreshToken`,
    {},
    { headers: jsonHeaders(`Bearer ${refreshToken || ''}`) },
  );

export const logoutApi = (accessToken) => {
  if (!accessToken) {
    return Promise.resolve();
  }
  return Axios.post(`${apiBaseUrl}/restaurants/logout`, {}, {
    headers: jsonHeaders(`Bearer ${accessToken}`),
  });
};

export const logoutAllDevicesApi = (accessToken) => {
  if (!accessToken) {
    return Promise.resolve();
  }
  return Axios.post(`${apiBaseUrl}/restaurants/logoutAllDevices`, {}, {
    headers: jsonHeaders(`Bearer ${accessToken}`),
  });
};
